/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect } from 'react';

import { Select } from '@atoms';
import { usePageTypeList } from '@api/hooks';
import { NARROW_COL } from '@constants';

import Form from '../Form';

import { FORM_FIELD } from './constants';

const PageTypeFormItem = ({ parentPageFieldName, initialParentPage, queryVariables, disabled, form, ...props }) => {
  const [allowedForTypeId, setAllowedForTypeId] = React.useState(queryVariables.allowedForTypeId);
  const [triggered, setTriggered] = React.useState(false);
  const { pageTypes, isFetching } = usePageTypeList({ allowedForTypeId });

  useEffect(() => {
    const pageType = form.getFieldValue(FORM_FIELD.PAGE_TYPE.name);
    if (pageTypes.length && pageType && !pageTypes.filter((type) => pageType?.name === type.name).length) {
      form.setFieldsValue({ [FORM_FIELD.PAGE_TYPE.name]: undefined });
    }
  }, [pageTypes, form]);

  return (
    <>
      <Form.WithFieldValue name={parentPageFieldName}>
        {(value) => {
          if (initialParentPage !== value) {
            setTriggered(true);
          }
          setAllowedForTypeId(value?.typeId || null);
        }}
      </Form.WithFieldValue>
      <Form.Item {...FORM_FIELD.PAGE_TYPE} wrapperCol={NARROW_COL} {...props}>
        <Select.Entities
          disabled={disabled && !triggered}
          loading={isFetching}
          placeholder="- Choose a page type -"
          entities={pageTypes}
        />
      </Form.Item>
    </>
  );
};

export default PageTypeFormItem;
